export default {
  enabled: true,
  items: [
    // { name: ':id_audience', classIcon: 'mdi mdi-poll', parent: '/audiences', parentId: 'id_audience', slug: 'audiences', },
    { name: 'overview', classIcon: 'mdi mdi-poll', parent: '/audiences', parentId: 'id_audience', slug: 'audiences', },
    { name: 'contacts', classIcon: 'mdi mdi-account-box-multiple', parent: '/audiences', parentId: 'id_audience', url: '/contacts', slug: 'contacts', },
    { name: 'settings', classIcon: 'mdi mdi-cog', parent: '/audiences', parentId: 'id_audience', url: '/settings', slug: 'audience-settings', },
  ],
}
